import { Box, SxProps } from '@mui/material';
import { Header } from '@/types/generated';
import NavigationBarItem from './NavigationBarItem/NavigationBarItem';
interface INavigationBar {
  navigationItems: Header['navigationLinksCollection'] | Header['secondaryNavigationLinksCollection'];
  navigationSx?: SxProps;
  navigationLinkSx?: SxProps;
  linkColor?: string;
  fontWeight?: string | number;
  showIconText?: boolean;
  dataTestId?: string;
}
export default function NavigationBar({
  navigationItems,
  navigationSx,
  navigationLinkSx,
  linkColor,
  fontWeight,
  showIconText = false,
  dataTestId = 'header_with_location_nav_main_navigation_bar'
}: Readonly<INavigationBar>) {
  return <Box data-testid={dataTestId} sx={navigationSx} data-sentry-element="Box" data-sentry-component="NavigationBar" data-sentry-source-file="NavigationBar.tsx">
			{navigationItems?.items?.map((item, index) => item ? <NavigationBarItem key={item.sys.id} item={item} itemIndex={index} navLinkStyles={navigationLinkSx} linkColor={linkColor} fontWeight={fontWeight} showIconText={showIconText} /> : null)}
		</Box>;
}